export const isEnabled = ff => {
  try {
    const __CONFIG_KEY = {
      key: ff,
      defaultValue: 'false'
    }

    // If ConfigDynamic not exist,
    // only check local overrided keys and window.configDynamic
    // because that is callBack cached config into page
    if (typeof window.ConfigDynamic === 'object') {
      return window.ConfigDynamic.isEnabled(__CONFIG_KEY)
    } else {
      const overridedKeys = localStorage.getItem('config-dynamic-keys-override')
      if (overridedKeys) {
        const dynamicConfigs = JSON.parse(overridedKeys)
        return (
          dynamicConfigs?.[__CONFIG_KEY.key] === true ||
          dynamicConfigs?.[__CONFIG_KEY.key] === 'true'
        )
      }

      if (window.configDynamic) {
        return (
          window.configDynamic?.[__CONFIG_KEY.key] === true ||
          window.configDynamic?.[__CONFIG_KEY.key] === 'true'
        )
      }
    }

    return false
  } catch (e) {
    console.log(e?.message)
    return false
  }
}
